import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { TODO } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';

export const ProgramsCombosCreateScheduleControllerModule = angular
  .module('acme.view.application.programs.combos.create.schedule.controllers', ['acme.common.service.api'])
  .controller('ProgramsCombosCreateScheduleController', [
    '$scope',
    '$state',
    'ApiService',
    'CalendarService',
    function ProgramsCombosCreateScheduleController(
      $scope: IScope & { programsCombosCreateSchedule: TODO },
      $state: StateService,
      ApiService: ApiService,
      CalendarService: CalendarService
    ) {
      const ctrl = {
        model: {
          startTime: new Date(),
          endTime: new Date(),
          singleDay: false,
        } as TODO,

        isSubmitted: false,
        cachedEndTime: null as Date | null,
        combo: null as TODO | null,
        next: null as TODO | null,

        init: function () {
          let titleLabel = 'Create Combo Schedule';

          $scope.$on('ProgramsCombosCreateController::save', ctrl.onSave);

          if ($state.params && $state.params.comboId) {
            ctrl.getCombo($state.params.comboId);
            titleLabel = 'Edit Combo Schedule';
          }

          const title = {
            title: titleLabel,
            buttonLeft: {
              label: 'Cancel',
              action: function () {
                $state.go('application.programs.combos.list');
              },
            },
            buttonRight: {
              label: 'Save & Close',
              action: () => {
                ctrl.complete(true);
              },
            },
          };

          $scope.$watch('programsCombosCreateSchedule.model.singleDay', ctrl.onSingleDayUpdate);
          $scope.$watch('programsCombosCreateSchedule.model.startTime', ctrl.onStartTimeUpdate);

          $scope.$emit('Application::contentTitleChange', title);
        },

        isValid: function () {
          return ctrl.isValidDateRange();
        },

        isValidDateRange: function () {
          let r = true;

          if (ctrl.isSubmitted) {
            r =
              ctrl.model.endTime &&
              ctrl.model.startTime &&
              ctrl.model.endTime.getTime() - ctrl.model.startTime.getTime() > 1;
          }

          return r;
        },

        onSave: function (e, data) {
          ctrl.next = data.state;
          ctrl.complete();
        },

        complete: function (close?: boolean) {
          const errorHandler = close ? ctrl.error.saveAndClose : ctrl.error.complete;
          const successHandler = close ? ctrl.success.saveAndClose : ctrl.success.complete;

          $scope.$emit('ProgramsCombosCreateController::reset');
          ctrl.isSubmitted = true;

          if (ctrl.isValid()) {
            if (ctrl.combo && ctrl.combo.id) {
              ApiService.combo.templates
                .update(ctrl.marshal.toJSON())
                .then((response) => successHandler(response))
                .catch((response) => errorHandler(response));
            } else {
              ApiService.combo.templates
                .create(ctrl.marshal.toJSON())
                .then((response) => successHandler(response))
                .catch((response) => errorHandler(response));
            }
          } else {
            $scope.$emit('ProgramsCombosCreateController::error', { message: 'Please correct the errors below.' });
          }
        },

        getCombo: function (id) {
          ApiService.combo.templates
            .get(id)
            .then((response) => ctrl.success.getCombo(response))
            .catch((response) => ctrl.error.getCombo(response));
        },

        success: {
          init: function (response) {},

          getCombo: function (response) {
            ctrl.marshal.fromJSON(response.data.payload);
          },

          complete: function (response) {
            ctrl.isSubmitted = true;
            $state.go(ctrl.next, { comboId: response.data.payload.id });
          },

          saveAndClose: function (response) {
            ctrl.isSubmitted = true;
            $scope.$emit('ProgramsCombosCreateController::success', { message: 'Successfully Saved!' });
            $scope.$emit('ProgramsCombosCreateController::transition', { state: 'application.programs.combos.list' });
          },
        },

        error: {
          init: function (response) {},
          getCombo: function (response) {},
          complete: function (response) {
            $scope.$emit('ProgramsCombosCreateController::error', { message: response.data.error });
          },
          saveAndClose: function (response) {
            $scope.$emit('ProgramsCombosCreateController::error', { message: response.data.error });
          },
        },

        marshal: {
          fromJSON: function (json) {
            ctrl.model.startTime = CalendarService.parseDate(json.startTime);
            ctrl.model.endTime = CalendarService.parseDate(json.endTime);

            const days = 1000 * 60 * 60 * 24;
            const diff = (ctrl.model.endTime.getTime() - ctrl.model.startTime.getTime()) / days;

            if (diff < 1) {
              ctrl.model.singleDay = true;
            }
            ctrl.combo = json;
          },

          toJSON: function () {
            ctrl.model.startTime = new Date(ctrl.model.startTime);
            ctrl.model.startTime.setHours(0);
            ctrl.model.startTime.setMinutes(0);
            ctrl.model.startTime.setSeconds(0);
            ctrl.model.startTime.setMilliseconds(0);

            ctrl.model.endTime = new Date(ctrl.model.endTime);
            ctrl.model.endTime.setHours(23);
            ctrl.model.endTime.setMinutes(59);
            ctrl.model.endTime.setSeconds(59);
            ctrl.model.endTime.setMilliseconds(999);

            if (ctrl.combo) {
              ctrl.combo.startTime = CalendarService.toISO8601(ctrl.model.startTime);
              ctrl.combo.endTime = CalendarService.toISO8601(ctrl.model.endTime);
            } else {
              ctrl.combo = {
                startTime: CalendarService.toISO8601(ctrl.model.startTime),
                endTime: CalendarService.toISO8601(ctrl.model.endTime),
              };
            }

            return ctrl.combo;
          },
        },

        onStartTimeUpdate: function (n, o) {
          const d = new Date(ctrl.model.startTime);
          d.setHours(23);
          d.setMinutes(59);
          d.setSeconds(59);
          d.setMilliseconds(999);

          if (ctrl.model.singleDay) {
            ctrl.model.endTime = d;
          } else if (ctrl.model.endTime) {
            if (ctrl.model.startTime.getTime() > ctrl.model.endTime.getTime()) {
              ctrl.model.endTime = d;
            }
          }
        },

        onSingleDayUpdate: function (n, o) {
          const d = new Date(ctrl.model.startTime);

          if (n) {
            ctrl.cachedEndTime = angular.copy(ctrl.model.endTime);
            d.setHours(23);
            d.setMinutes(59);
            d.setSeconds(59);
            d.setMilliseconds(999);
            ctrl.model.endTime = d;
          } else {
            ctrl.model.endTime = angular.copy(ctrl.cachedEndTime);
          }
        },
      };

      $scope.programsCombosCreateSchedule = ctrl;
      ctrl.init();
    },
  ]).name;
